import { mString } from 'lib/helpers/utility';

import DrAvatar from './lib/components/DrAvatar';
import AmountBadge from './lib/components/AmountBadge';
import InfoCallout from './lib/components/InfoCallout';
import SlideHeader from './lib/components/SlideHeader';
import SpeechBubble from './lib/components/SpeechBubble';

const DeductiblePage = ({ estimate }) => {
  const annual = estimate?.benefitSummary?.deductible?.annual ?? null;
  const remaining = estimate?.benefitSummary?.deductible?.remaining ?? null;
  const paid = annual != null && remaining != null ? Math.max(0, annual - remaining) : null;
  const appliedThisVisit = estimate?.deductible ?? 0;

  return (
    <div className="flex flex-col gap-5">
      <SlideHeader title="Coverage" />

      <div className="flex items-end gap-4">
        <DrAvatar size="medium" variant={2} className="shrink-0" />
        <SpeechBubble variant="highlight" tail="left">
          Today's services count toward your <span className="font-600 italic">deductible</span> —
          the amount you pay each year before insurance starts sharing the cost.
          {annual != null && paid != null
            ? ` Your annual deductible is ${mString(annual)} and you've already paid ${mString(
                paid
              )} this year.`
            : ''}
        </SpeechBubble>
      </div>

      {remaining != null && (
        <>
          <SpeechBubble variant="default">Your remaining deductible is</SpeechBubble>

          <div className="flex justify-center">
            <AmountBadge amount={remaining} />
          </div>
        </>
      )}

      <p className="text-center text-sm text-neutral-600">
        {appliedThisVisit > 0
          ? `The first ${mString(
              appliedThisVisit
            )} of today's visit goes toward finishing your deductible. After that, your insurance picks up most of the rest — you only pay your share (called coinsurance).`
          : "Once you've met your deductible, your insurance picks up most of the cost — you only pay your share (called coinsurance)."}
      </p>

      <InfoCallout />
    </div>
  );
};

export default DeductiblePage;
